<template>
    <div class="hire-banner__right-child-teleported me-2 " style="" :class="{'' : !isTeleported}">
      <div class="d-flex w-100">
        <span class="mb-md-3 m-2" style="font-size: 16px;line-height: 15px; font-weight: 500;" :class="{'my-2' : isTeleported}">{{ this.spanCopy }}</span>
        <div class="d-flex cta-cont-desk-mobile-2" :class="{'mb-0 mb-md-3 cta-cont-desk-mobile' : !isTeleported, 'flex-row align-items-center justify-content-between' : isTeleported}">
          <div class="d-flex align-items-end w-100">
            <span class="space-price text-nowrap d-flex flex-nowrap align-items-end me-2">
              $ {{sku.price.toLocaleString("en", {useGrouping: true})}}
            </span>
            
            <span class="space-price text-nowrap d-flex flex-nowrap align-items-end" style="line-height: 23px;">
                <span class="mb-md-2" style="color: var(--space-txt-color);font-weight: 800">{{sku.currency}}</span>
                <span class="mx-2 mb-md-2" > / </span>
                <span class="mb-md-2" v-html="' '+productPeriodicity('long') + (variationDescription?.minimum_contract_timeframe? '*' : '') "></span>
            </span>
          </div>
          

          <a v-if="productSlug == 'team-space' || productSlug == 'meeting-space'" href="#spaceAnchor" class="button-space big w-100 me-0 me-sm-5 p-2 px-lg-5">
            {{ this.locale == 'en' ? 'Hire now' : ' Contrata ahora' }}
          </a>
          <a v-else :href="urlQueryString" class="button-space big w-100 me-0 me-sm-5 p-2 px-lg-5">
            {{ this.locale == 'en' ? 'Hire now' : 'Contrata ahora' }}
          </a>
        </div>
      </div>
    </div>
</template>
<script>
import spaceMixin from '../space-mixin'

export default {
  inject: ['locale'],
  mixins: [spaceMixin],
  props:{
    product: Object,
    isTeleported: Boolean,
  },
  data() {
    return {
      spanCopyOptions: 
      {
        productEn: 'Get your space from', 
        productEs: 'Contrata tu espacio por',
        noProductEn: 'Reserve your space starting from',
        noProductEs: 'Reserva tu espacio'
      },
      spanCopy: "",
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.locale == "en" && this.spaceName == "team-space" ||  this.spaceName == "meeting-space"){
        this.spanCopy = this.spanCopyOptions.noProductEn;
      }
      else if (this.locale == "es" && this.spaceName == "team-space" ||  this.spaceName == "meeting-space"){
        this.spanCopy = this.spanCopyOptions.noProductEs;
      }
      else if (this.locale == "en"){
        this.spanCopy = this.spanCopyOptions.productEn;
      }
      else if (this.locale == "es"){
        this.spanCopy = this.spanCopyOptions.productEs;
      }
      
    });
  },
  computed: {
    productSlug() {
      return this.product && this.product?.slug ? this.product.slug : '#';
    },
    sku() {
      if (this.product && this.product?.relationships?.product?.skus?.length > 0) {
        return this.product.relationships.product.skus[0];
      }
      return null;
    },
    variationDescription() {
      let variationDescription = null;
      if (this.product?.space_details_for_variations) {
        variationDescription = this.product.space_details_for_variations.length > 1 ? this.product.space_details_for_variations.find( x => x.identifier === this.sku) : this.product.space_details_for_variations[0]
      }
      return variationDescription;
    },
    urlQueryString() {
      let url = null;
      let sku = this.activeSku ? this.activeSku : this.productSlug;
      let spots = this.spots ? this.spots : this.variationDescription?.min_people_spaces_restriction;
      let hours = this.hours ? this.hours : this.variationDescription?.min_hours_restriction;
      let foodOption = this.foodOption ? this.foodOption : 'none';
      url = `/${this.locale}/checkout/${this.productSlug}?sku=${sku}&spaces=${spots}&hours=${hours}&foodOption=${foodOption}`
      return url;
    },
      spaceName(){
          return this.product.slug
      }
  }
}
</script>
<style lang="scss">
.hire-banner__right-child{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  align-items: flex-end;
  justify-content: flex-start;
  border-left: none;
  padding-inline: 0;
  margin-inline: 0;
  @media screen and (max-width:767px) {
    border-left: none;
  }
  >div{
    flex-direction: column;
  }
}
.hire-banner__right-child-teleported{
  width: auto;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width:800px) {
    border-left: none;
  }
  border-left: 1px solid var(--light-muted); 
  padding-inline-start: clamp(15px, 4vw, 60px);
  margin-inline-start: clamp(15px, 4vw, 60px);
  @media screen and (max-width:767px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    align-items: center;
    background-color: white;
    z-index: 11;
    flex-direction: row;
    flex-wrap: nowrap;
    padding-inline: clamp(15px, 4vw, 60px);
    padding-block: 10px;
    padding-top: 5px;
    -webkit-box-shadow: 0px -6px 5px -1px rgba(0,0,0,0.1); 
    box-shadow: 0px -6px 5px -1px rgba(0,0,0,0.1);
    margin-inline: 0;
    margin-inline-start: 0px !important;
    .space-price{
      color: var(--space-txt-color);
      font-size: 25px;
      font-weight: 800;
      line-height: 25px;
    }
    .space-price + .space-price{
        color: var(--muted);
        font-size: 12px;
        font-weight: 500;
    }
  }
  >div{
    flex-direction: column;
  }
}
.cta-cont-desk-mobile{
  align-items: center;
  flex-wrap: wrap;
}

.cta-cont-desk-mobile-2{
  align-items: center;
  gap: 5px 20px;
  @media screen and (max-width:991px){
    flex-wrap: wrap;
  }
  @media screen and (max-width:768px){
    flex-wrap: nowrap;
    width: 100%;
    justify-content: space-between;
  }
}

</style>